import React from 'react';
import Hero from '../components/Hero';
import PaymentMarquee from '../components/PaymentMarquee';
import FeatureCards from '../components/FeatureCards';
import SplitSection from '../components/SplitSection';
import Steps from '../components/Steps';
import AISection from '../components/AISection';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';
import { images } from '../mock';

const Home = ({ onDownload }) => {
  return (
    <div>
      <Hero onDownload={onDownload} />
      <PaymentMarquee />
      <FeatureCards />

      <SplitSection
        theme="mint"
        eyebrow="Tap to Pay"
        title="Your phone is the"
        titleAccent="card reader."
        paragraph="Never lose a sale to \u201ccash only\u201d again. Accept contactless cards and wallets with just your phone — no dongles, no rentals, no hidden costs."
        bullets={['Debit, credit, Apple Pay & Google Pay', 'Add a tip in one tap', 'Just 1.4% per in-person sale']}
        ctaLabel="Start selling now"
        onCta={onDownload}
        image={images.contactless}
      />

      <SplitSection
        theme="light"
        reverse
        eyebrow="Payment Links"
        title="Sell from"
        titleAccent="anywhere."
        paragraph="Not face to face? Send a payment link by text, DM or email. Your customer clicks and pays — no app, no sign-up — and you’re paid in seconds."
        bullets={['Share by text, DM or email', 'No app needed for customers', 'Flat 3.9% + $0.30 per link']}
        ctaLabel="Send a link"
        onCta={onDownload}
        image={images.vendor}
      />

      <Steps onDownload={onDownload} />

      <SplitSection
        theme="mint"
        eyebrow="Storefront"
        title="Your business site, live in"
        titleAccent="minutes."
        paragraph="FLIX builds a clean, professional storefront from your business info — no code, no designer, no $49/month plan. Payments are built right in."
        bullets={['Totally free', 'Add a catalog', 'Payments built in', 'Fully customizable']}
        ctaLabel="Build my storefront"
        onCta={onDownload}
        image={images.florist2}
      />

      <AISection onDownload={onDownload} />
      <Testimonials />
      <CTASection onDownload={onDownload} />
      <FAQ />
    </div>
  );
};

export default Home;
